import React from "react";
import { AUTH_IDENTITY_PROVIDER } from "../identityprovider";
import { AzureBootstrap } from "./azurebootstrap";
import { OktaBootstrap } from "./oktabootstrap";

interface AuthBootstrapProps {
    children: React.ReactNode;
}

export const AuthBootstrap: React.FC<AuthBootstrapProps> = ({ children }) => {
    switch (AUTH_IDENTITY_PROVIDER) {
        case "AZURE_AD":
            return <AzureBootstrap>{children}</AzureBootstrap>;

        case "OKTA":
            return <OktaBootstrap>{children}</OktaBootstrap>;

        default:
            throw new Error(
                `Unsupported REACT_APP_AUTH_IDENTITY_PROVIDER: ${AUTH_IDENTITY_PROVIDER}`
            );
    }
};